import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';

import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { inject } from '@angular/core';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> =>
{
    const authService = inject(AuthService);

    // Clone the request object
    let newReq = req.clone();

    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.
    if ( authService.accessToken && !AuthUtils.isTokenExpired(authService.accessToken) )
    {
        newReq = req.clone({
            headers: req.headers.set('Authorization', 'Bearer ' + authService.accessToken),
        });
    }

    // Response
    return next(newReq).pipe(
        catchError((error) =>
        {
            // if ( error instanceof HttpErrorResponse && error.status === 401 ){

            // } else if (error instanceof HttpErrorResponse && error.status === 404) {
            //     if (error.message && error.message.includes('hacienda')){
            //         _snackBar.open(
            //             'No se ha encontrado la cédula en la base de datos de Hacienda',
            //             'OK',
            //             {
            //                 duration: 3000,
            //                 horizontalPosition: 'center',
            //                 verticalPosition: 'top',
            //                 panelClass: ['warn-snackbar'],
            //             }
            //         );   
            //         return; 
            //     }
            //     if (error.error.error) {
            //         _snackBar.open(
            //             error.error.error,
            //             'OK',
            //             {
            //                 duration: 3000,
            //                 horizontalPosition: 'center',
            //                 verticalPosition: 'top',
            //                 panelClass: ['error-snackbar'],
            //             }
            //         );
            //         return; 
            //     }  
            //     _router.navigateByUrl('/404');
            // } else if (error instanceof HttpErrorResponse && error.status === 403) {
            //     _router.navigateByUrl('/403');
            // }
            return throwError(() => error);
    }),
    );
};
